import { useEffect, useState } from "react";
import { getCharacterBios } from "../lib/api";

/**
 * Fetches the admin-editable character bios once per app load and merges
 * them over the static `defaults` list keyed by `slug`. Any bio slug not
 * present in the DB falls back to the compiled-in default.
 */
export default function useCharacterBios(defaults) {
  const [bios, setBios] = useState(defaults);

  useEffect(() => {
    let cancelled = false;
    getCharacterBios()
      .then((dbMap) => {
        if (cancelled) return;
        setBios(
          defaults.map((d) => {
            const dbBio = dbMap[d.slug];
            if (!dbBio) return d;
            return {
              ...d,
              role: dbBio.role || d.role,
              intro: dbBio.intro || d.intro,
            };
          })
        );
      })
      .catch(() => {
        // silently fall back to compiled-in defaults
      });
    return () => {
      cancelled = true;
    };
  }, [defaults]);

  return bios;
}

/**
 * Single-slug variant used by MeetTheFamily group cards.
 */
export function useCharacterBio(slug, fallback = { role: "", intro: "" }) {
  const [bio, setBio] = useState(fallback);
  useEffect(() => {
    let cancelled = false;
    getCharacterBios()
      .then((dbMap) => {
        if (cancelled) return;
        const dbBio = dbMap[slug];
        if (dbBio) {
          setBio({
            role: dbBio.role || fallback.role,
            intro: dbBio.intro || fallback.intro,
          });
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [slug]);
  return bio;
}
